<template>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="6" lg="4">
          <v-card class="rounded-xl elevation-4">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-map-marker-plus</v-icon>
              <span class="headline font-weight-bold">Cadastrar Local</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="pa-6">
              <v-form ref="form" v-model="valid" @submit.prevent="cadastrarLocal">
                <v-text-field
                  v-model="nomeLocal"
                  label="Nome do Local"
                  outlined
                  :rules="nomeRules"
                  prepend-icon="mdi-rename-box"
                  class="mb-4"
                  required
                ></v-text-field>

                <v-checkbox
                  v-model="automatico"
                  label="Este local é automático?"
                  :true-value="1"
                  :false-value="0"
                  class="mt-0 mb-4"
                ></v-checkbox>

                <v-checkbox
                  v-model="checkbox"
                  :rules="[v => !!v || 'Você deve concordar para continuar']"
                  label="Confirmo que as informações estão corretas"
                  required
                  class="mt-0"
                ></v-checkbox>

                <v-alert
                  v-model="erroEditar"
                  color="error"
                  icon="mdi-alert-circle"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Ocorreu um erro ao cadastrar o local!
                </v-alert>

                <v-alert
                  v-model="sucessoEditar"
                  color="success"
                  icon="mdi-check-circle"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Local cadastrado com sucesso!
                </v-alert>
              </v-form>
            </v-card-text>

            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn
                large
                outlined
                color="grey darken-1"
                :to="{ path: '/listaLocaisUnidade' }"
                class="mr-3"
              >
                <v-icon left>mdi-arrow-left</v-icon>
                Voltar
              </v-btn>
              <v-btn
                color="primary"
                large
                depressed
                :disabled="!valid"
                :loading="loading"
                @click="cadastrarLocal"
                class="px-6"
              >
                <v-icon left>mdi-content-save</v-icon>
                Cadastrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'CadastrarLocalUnidade',
  data () {
    return {
      valid: false,
      loading: false,
      erroEditar: false,
      sucessoEditar: false,
      nomeLocal: '',
      automatico: 0,
      checkbox: false,
      nomeRules: [
        v => !!v || 'Nome do local é obrigatório',
        v => (v && v.length >= 6) || 'Nome deve ter pelo menos 6 caracteres'
      ]
    }
  },
  methods: {
    async cadastrarLocal () {
      if (!this.$refs.form.validate()) return

      this.loading = true
      this.erroEditar = false
      this.sucessoEditar = false

      try {
        const response = await administradorUnidadeService.administradorUnidade.cadastrarLocal(
          this.nomeLocal,
          this.automatico
        )

        if (response.data === 'erro') {
          this.erroEditar = true
          return
        }

        if (response.data === true) {
          this.sucessoEditar = true
          this.$refs.form.reset()
          setTimeout(() => {
            this.$router.push('/listaLocaisUnidade')
          }, 1500)
        }
      } catch (error) {
        console.error('Erro ao cadastrar local:', error)
        this.erroEditar = true
      } finally {
        this.loading = false
      }
    },
    clear () {
      this.$refs.form.reset()
    }
  }
}
</script>

<style scoped>
.rounded-xl {
  border-radius: 16px !important;
}

.v-card__title {
  border-top-left-radius: 16px !important;
  border-top-right-radius: 16px !important;
}

.v-btn {
  letter-spacing: normal;
  text-transform: none;
}

.v-btn--disabled {
  opacity: 0.6;
}
</style>
